/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */
import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDCard from "components/MDCard";

// @mui material components
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";

// import Icon from "@mui/material/Icon";
import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

// React-Select component and styling
import Select from "react-select";


import { CustomToastContent } from "../../../examples/CustomToastContent/index";

//  config file
import Config from "../../../config/index";

// Functions from store
import {
  getWarehouses,
  getPackaging,
  getDppIds,
  getItemMaster,
  getZonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getSubModulesByRoleId,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getAcn,
  createPackaging,
  uploadForPackaging,
  getRelationLocation,
  getWarehousesByMovement,
  deletePackaging,
  editPackaging,
  getLevelsByWarehouse,
  getDynamicColumn,
  createDynamicColumn,
  getSupplierType,
} from "../../../store";

// Cookies
import Cookies from "universal-cookie";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
import { addMinutes, format } from "date-fns";
import { Backdrop } from "@mui/material";
import MDInput from "components/MDInput";
import { CSVLink } from "react-csv";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import DownloadButton from "components/standardized-components/DownloadButton";

const cookies = new Cookies();

const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "auto",
  overflowX: "hidden",
};

// const styleForEdit = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: { xs: 350, lg: 750 },
//   boxShadow: 24,
//   p: 1,
//   pt: 3,
// };

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 850 },
  maxHeight: "90vh",
  overflowY: "auto",
  boxShadow: 24,
  p: 2,
  pt: 2,
  borderRadius: 2,
  backgroundColor: "#fff",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Packaging = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,

  createDynamicColumn,
  getWarehouses,
  deletePackaging,
  warehouses,
  getPackaging,
  getDppIds,
  getPackagingReducer,
  getItemMaster,
  getDynamicColumn,
  itemMaster,
  getZonesByWarehouse,
  zonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getRelationLocationReducer,
  getLevel1ByLevel,
  getWarehouseByMovementReducer,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel1ByLevelReducer,
  getLevel2ByLevelReducer,
  getLevel3ByLevelReducer,
  getLevel4ByLevel,
  getLevel4ByLevelReducer,
  editPackaging,
  getAcn,
  getAcnReducer,
  getRelationLocation,
  createPackaging,
  getWarehousesByMovement,
  uploadForPackaging,
  getLevelsByWarehouse,
  levelsByWarehouseReducer,
  dppIdSelectedForGlobalFilter,

  getDynamicColumnReducer,
  getSupplierTypeReducer,
  getDPPReducer,
  getSupplierType
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let userId = loginDetails.data.userId;
  console.log("userId", userId)
  console.log("loginDetails", loginDetails)
  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    getSupplierType(jwtToken);
  }, []);

  const [supplierIdSelected, setSupplierIdSelected] = useState("");

  const handleChangeSupplier = (selectedData) => {
    setSupplierIdSelected(selectedData);

  };
  const [supplierIdSelectedForEdit, setSupplierIdSelectedForEdit] = useState("");

  const handleChangeSupplierForEdit = (selectedData) => {
    setSupplierIdSelectedForEdit(selectedData);

  };

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : []
    );
  }, [getSubModulesByRoleIdReducer]);

  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "7e02c688-4e21-4805-9f51-2320dda92382"
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "fbbd1f44-b96f-43ae-9b8d-f05e63ada3f7"
    )
    : null;

  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "825e65a6-0f01-4fe7-91a1-63cb571b093a"
    )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "91e53aa0-12f0-4128-b70f-64e1d712f187"
    )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "6087b022-979c-45e8-ab4e-128f0c3128ec"
    )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  const [warehouseIdSelected, setWarehouseIdSelected] = useState("");
  const [zoneIdSelected, setZoneIdSelected] = useState("");
  const [sectionIdSelected, setSectionIdSelected] = useState("");
  const [rackIdSelected, setRackIdSelected] = useState("");
  const [locationIdSelected, setLocationIdSelected] = useState("");
  const [activityIdSelected, setActivityIdSelected] = useState("");

  const handleActivityIdChange = (selectedActivity) => {
    setActivityIdSelected(selectedActivity);
    setWarehouseIdSelected("");
  };

  const handleChangeWarehouse = (selectedData) => {
    setWarehouseIdSelected(selectedData);
  };


  const [dppIdSelected, setdppIdSelected] = useState("");

  const handleChangeDpp = (selectedData) => {
    setdppIdSelected(selectedData);

  };


  useEffect(() => {
    if (dppIdSelectedForGlobalFilter) {
      setdppIdSelected(dppIdSelectedForGlobalFilter);
    }
  }, [dppIdSelectedForGlobalFilter]);




  useEffect(() => {
    if (dppIdSelectedForGlobalFilter?.value) {
      // Fetch with dppId + jwtToken
      getPackaging(dppIdSelectedForGlobalFilter?.value, jwtToken);
    } else {
      // Fetch without filter
      getPackaging(null, jwtToken);
    }
  }, [dppIdSelectedForGlobalFilter, jwtToken]);

  const [dppOptions, setDPPOptions] = useState([]);

  useEffect(() => {
    let tempgetDPPReducer = [];
    let data = getDPPReducer.dpp.data ? getDPPReducer.dpp.data : [];
    data.map((zone) => {
      tempgetDPPReducer.push({
        label: zone.dppCode,
        value: zone.dppId,
      });
    });
    setDPPOptions(tempgetDPPReducer);
  }, [getDPPReducer]);

  const [dppIdForUpdateSelected, setdppIdForUpdateSelected] = useState("");
  const handleChangeDppForUpdate = (selectedData) => {
    setdppIdForUpdateSelected(selectedData);
  };
  useEffect(() => {
    getDppIds(jwtToken);
  }, []);

  const handleZoneIDChange = (selectedRack) => {
    setZoneIdSelected(selectedRack);
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleSectionIdChange = (selectedRack) => {
    setSectionIdSelected(selectedRack);
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleRackIdChange = (selectedRack) => {
    setRackIdSelected(selectedRack);
    setLocationIdSelected("");
  };

  const handleLocationIdChange = (selectedLocation) => {
    setLocationIdSelected(selectedLocation);
  };

  // useEffect(() => {
  //   getPackaging(jwtToken);
  // }, []);

  const [selectedZoneName, setSelectedZoneName] = useState("");

  const handleZoneNameChange = (selectedZoneName) => {
    setSelectedZoneName(selectedZoneName);
    setRackIdSelected("");
  };

  // let dateOnly = output.split(' ')[0];
  const [state, setState] = useState({
    columns: [
      { Header: "PKG ID", accessor: "pkgId" },
      { Header: "DPP Code", accessor: "dppCode" },
      { Header: "Material Type", accessor: "packagingMaterialType" },
      { Header: "Recyclable (%)", accessor: "recyclablePercent" },
      { Header: "Supplier ID", accessor: "supplierId" },
      { Header: "Disposal Method", accessor: "disposalMethod" },
      { Header: "Collection Program	", accessor: "collectionProgram" },

      { Header: "Material Source", accessor: "materialSource" },
      { Header: "Plastic Content (%)", accessor: "plasticContent" },
      { Header: "Biodegradability (%)", accessor: "biodegradability" },
      { Header: "Carbon Footprint (kg CO₂)", accessor: "carbonFootprint" },
      { Header: "Waste Generation (kg/capita)", accessor: "wasteGeneration" },
      { Header: "Reusability (cycles)", accessor: "reusability" },
      { Header: "Disposal Instructions", accessor: "disposalInstructions" },
      { Header: "Take Back Program", accessor: "takeBackProgram" },
      { Header: "packaging Weight (kg)", accessor: "packagingWeight" },

      // { Header: "Melt/Heat Number", accessor: "meltHeatNumber" },
      // { Header: "Production Batch", accessor: "productionCastingBatch" },
      // { Header: "Material Grade", accessor: "materialGrade" },
      // { Header: "Casting Process", accessor: "castingProcess" },
      // { Header: "Casting Date", accessor: "pouringCastingDate" },



      {
        Header: "Audit Date",
        accessor: "auditDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(new Date(value), "dd/MM/yyyy")
            : "";
        },
      },


      { Header: "Created By", accessor: "cdBy" },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  // const headers = [
  //   { label: "pkgId", key: "pkgId" },
  //   { label: "dppCode", key: "dppCode" },
  //   { label: "packagingMaterialType", key: "packagingMaterialType" },
  //   { label: "recyclablePercent", key: "recyclablePercent" },
  //   { label: "supplierId", key: "supplierId" },
  //   { label: "disposalMethod", key: "disposalMethod" },
  //   { label: "collectionProgram", key: "collectionProgram" },

  //   { label: "auditDate", key: "createdDate" },
  //   { label: "Material Source", key: "materialSource" },
  //   { label: "packagingWeight", key: "packagingWeight" },
  //   { label: "Plastic Content", key: "plasticContent" },
  //   { label: "Biodegradability", key: "biodegradability" },
  //   { label: "Carbon Footprint", key: "carbonFootprint" },
  //   { label: "Waste Generation", key: "wasteGeneration" },
  //   { label: "Reusability", key: "reusability" },
  //   { label: "Disposal Instructions", key: "disposalInstructions" },
  //   { label: "Take Back Program", key: "takeBackProgram" },
  //   { label: "cdBy", key: "cdBy" },

  // ];
  // const headersForTemp = [
  //   { label: "dppCode", key: "dppCode" },
  //   { label: "packagingMaterialType", key: "packagingMaterialType" },
  //   { label: "recyclablePercent", key: "recyclablePercent" },
  //   { label: "supplierName", key: "supplierName" },
  //   { label: "disposalMethod", key: "disposalMethod" },
  //   { label: "collectionProgram", key: "collectionProgram" },
  //   { label: "auditDate", key: "auditDate" },
  //   { label: "materialSource", key: "materialSource" },
  //   { label: "packagingWeight", key: "packagingWeight" },
  //   { label: "plasticContent", key: "plasticContent" },
  //   { label: "biodegradability", key: "biodegradability" },
  //   { label: "carbonFootprint", key: "carbonFootprint" },
  //   { label: "wasteGeneration", key: "wasteGeneration" },
  //   { label: "reusability", key: "reusability" },
  //   { label: "disposalInstructions", key: "disposalInstructions" },
  //   { label: "takeBackProgram", key: "takeBackProgram" }
  // ];


  // --- 1. Table Data Download (Listing) ke Headers ---
  // Isme 'label' ko proper format mein likha hai taaki download hone par excel mein heading achhi dikhe

  const headers = [
    { label: "DPP Code", key: "dppCode" },
    { label: "Packaging Material Type", key: "packagingMaterialType" },
    { label: "Recyclable Percent", key: "recyclablePercent" },
    { label: "Supplier Name", key: "supplierName" },
    { label: "Disposal Method", key: "disposalMethod" },
    { label: "Collection Program", key: "collectionProgram" },
    { label: "Audit Date", key: "auditDate" },
    { label: "Material Source", key: "materialSource" },
    { label: "Packaging Weight", key: "packagingWeight" },
    { label: "Carbon Footprint", key: "carbonFootprint" },
    { label: "Waste Generation", key: "wasteGeneration" },
    { label: "Reusability Cycles", key: "reusabilityCycles" },
    { label: "Disposal Instructions", key: "disposalInstructions" },
    { label: "Take Back Program", key: "takeBackProgram" }
    // { label: "Pkg ID", key: "pkgId" },
    // { label: "Created By", key: "cdBy" },
  ];

  const headersForTemp = [
    { label: "dppCode", key: "dppCode" },
    { label: "packagingMaterialType", key: "packagingMaterialType" },
    { label: "recyclablePercent", key: "recyclablePercent" },
    { label: "supplierName", key: "supplierName" },
    { label: "disposalMethod", key: "disposalMethod" },
    { label: "collectionProgram", key: "collectionProgram" },
    { label: "auditDate", key: "auditDate" },
    { label: "materialSource", key: "materialSource" },
    { label: "packagingWeight", key: "packagingWeight" },
    { label: "carbonFootprint", key: "carbonFootprint" },
    { label: "wasteGeneration", key: "wasteGeneration" },
    { label: "reusabilityCycles", key: "reusabilityCycles" },
    { label: "disposalInstructions", key: "disposalInstructions" },
    { label: "takeBackProgram", key: "takeBackProgram" }
  ];

  const csvLink = {
    filename: "Packaging List.csv",
    headers: headers,
    data: rows,
  };

  const csvLink2 = {
    filename: "Packaging Template.csv",
    headers: headersForTemp,
    data: [],
  };




  useEffect(() => {
    let tempMappedActivity = [];
    let data = getPackagingReducer.package.data
      ? getPackagingReducer.package.data
      : [];
    console.log(data);
    // setPaginationObj(getPackagingReducer?.package?.pagination);
    setLoading(getPackagingReducer.loading);

    data.map((item) => {
      const formatDate = new Date(item.auditDate);
      let itemDescription = item.itemDescription;
      let len = desLength;

      const itemObject = {
        privateKey: item.itemCode,
        itemCodeDes: `${item.itemCode} / ${itemDescription ? itemDescription.substring(0, len) : ""
          }`,
        pkgId: item.pkgId,
        dppCode: item.dppCode,
        materialSource: item.materialSource,
        plasticContent: item.plasticContent,
        biodegradability: item.biodegradability,
        carbonFootprint: item.carbonFootprint,
        wasteGeneration: item.wasteGeneration,
        reusability: item.reusability,
        disposalInstructions: item.disposalInstructions,
        takeBackProgram: item.takeBackProgram,
        packagingWeight: item.packagingWeight,
        auditDate: item.auditDate,
        packagingMaterialType: item.packagingMaterialType,
        recyclablePercent: item.recyclablePercent,
        supplierId: item.supplierId,
        disposalMethod: item.disposalMethod,
        collectionProgram: item.collectionProgram,

        // meltHeatNumber: item.meltHeatNumber,
        // productionCastingBatch: item.productionCastingBatch,
        // materialGrade: item.materialGrade,
        // castingProcess: item.castingProcess,
        // pouringCastingDate: item.pouringCastingDate,
        cdBy: item.cdBy,

        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {item?.itemDescription?.length > 35 ? (
              <Tooltip
                title={item.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {item.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {item.itemDescription}
              </MDTypography>
            )}
            {item?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        id: item.id,
        categoryCode: item.categoryCode,
        warehouse: item.warehouseCode,
        zone: item.zone,
        section: item.section,

        createdDate: format(new Date(formatDate), "dd/MM/yyyy"),
        cd: item.cd,
        rack: item.rack,
        location: item.location,
        // itemName: des ? des.substring(0, len) : "",
        acnCode: item.acnCode,
        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => {
                  handleOpenUpdateModal(item);
                }}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    viewAccess && setState({ ...state, rows: tempMappedActivity });
  }, [getPackagingReducer]);

  const [activityOptions, setActivityOptions] = useState([]);

  useEffect(() => {
    let tempActivityOptions = [];
    let data = getAcnReducer.acn.data ? getAcnReducer.acn.data : [];
    data.map((activity) => {
      tempActivityOptions.push({
        label: activity.acnName,
        value: activity.acnId,
      });
    });
    setActivityOptions(tempActivityOptions);
  }, [getAcnReducer]);

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = warehouses.warehouses ? warehouses.warehouses : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptions(tempWarehouseOptions);
  }, [warehouses]);

  const [warehouseOptionsByMovement, setWarehouseOptionsByMovement] = useState(
    []
  );

  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = getWarehouseByMovementReducer.warehouses.data
      ? getWarehouseByMovementReducer.warehouses.data
      : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptionsByMovement(tempWarehouseOptions);
  }, [getWarehouseByMovementReducer]);
  // useEffect(() => {
  //   let tempLevelOptions = [];
  //   let data = getRelationLocationReducer.locations.data
  //     ? getRelationLocationReducer.locations.data
  //     : [];

  //   data.map((level) => {
  //     tempLevelOptions.push({
  //       label: level.rltName,
  //       value: level.rltLevel,
  //     });
  //   });
  //   setLevelOptions(tempLevelOptions);
  // }, [getRelationLocationReducer]);

  // let level1Name = getRelationLocationReducer.locations.data

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [zoneOptions, setZoneOptions] = useState([]);

  useEffect(() => {
    let tempZonesByWarehouse = [];
    let data = zonesByWarehouse.zones.data ? zonesByWarehouse.zones.data : [];
    data.map((zone) => {
      tempZonesByWarehouse.push({
        label: zone.zoneName,
        value: zone.id,
      });
    });
    setZoneOptions(tempZonesByWarehouse);
  }, [zonesByWarehouse]);

  // useEffect(() => {
  //   getLevelsByWarehouse(warehouseIdSelected?.value, jwtToken);
  // }, [warehouseIdSelected]);

  const [levelOptions, setLevelOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = levelsByWarehouseReducer.levelsByWarehouse.data
      ? levelsByWarehouseReducer.levelsByWarehouse.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level?.rltName,
        value: level?.rltLevel,
      });
    });
    setLevelOptions(tempLevelOptions);
  }, [levelsByWarehouseReducer]);

  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel1ByLevelReducer.level1ByLevel.data
      ? getLevel1ByLevelReducer.level1ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel1Options(tempLevelOptions);
  }, [getLevel1ByLevelReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel2Options(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelReducer.level3ByLevel.data
      ? getLevel3ByLevelReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel3Options(tempLevelOptions);
  }, [getLevel3ByLevelReducer]);

  const [level4Options, setLevel4Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel4ByLevelReducer.level4ByLevel.data
      ? getLevel4ByLevelReducer.level4ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel4Options(tempLevelOptions);
  }, [getLevel4ByLevelReducer]);

  const [openBinsOptions, setOpenBinsOptions] = useState([]);

  const [loading, setLoading] = useState(true);

  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);

  useEffect(() => {
    if (isSuccessAllocateItem) {
      setTimeout(() => {
        setIsSuccessAllocateItem(false);
      }, 3000);
    }
  }, [isSuccessAllocateItem]);

  useEffect(() => {
    if (isErrorAllocateItem) {
      setTimeout(() => {
        setIsErrorAllocateItem(false);
      }, 3000);
    }
  }, [isErrorAllocateItem]);

  const [allocateItemModal, setAllocateItemModal] = useState(false);
  const handleAllocateItemModal = () => {
    setAllocateItemModal(!allocateItemModal);

    formik.setErrors({});
    setZoneIdSelected("");
    setWarehouseIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleCloseAllocateItemModal = (event, reason) => {
    if (reason === "backdropClick")
      return;
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});
    setdppIdSelected("");
    setSupplierIdSelected("")

    formik.setValues(initialValues);
    setWarehouseIdSelected("");
    setLocationIdSelected("");
    setActivityIdSelected("");
    setSelectedItemCode("");
  };

  const [ActivityMappingData, setActivityMappingData] = useState({});

  const [selectedItemCode, setSelectedItemCode] = useState("");

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };

  const [selectedBin, setSelectedBin] = useState("");

  const handleBinChange = (selectedBin) => {
    setSelectedBin(selectedBin);
  };
  const [selectedBinForAdd, setSelectedBinForAdd] = useState("");

  const handleBinChangeForAdd = (selectedBinForAdd) => {
    setSelectedBinForAdd(selectedBinForAdd);
  };

  const [selectedOpenBin, setSelectedOpenBin] = useState(
    ActivityMappingData?.locationName
  );

  useEffect(() => {
    if (ActivityMappingData) {
      setSelectedOpenBin({
        label: ActivityMappingData?.locationName,
        value: ActivityMappingData?.locationName,
      });
    }
  }, [ActivityMappingData]);

  const handleOpenBinChange = (selectedOpenBin) => {
    setSelectedOpenBin(selectedOpenBin);
  };

  const initialValues = {
    DPPID: "",
    MaterialType: "",
    Recyclablepercent: "",
    SupplierId: "",
    Method: "",
    Collection: "",
    AuditDate: "",
    MaterialSource: "",
    PlasticContent: "",
    Biodegradability: "",
    CarbonFootprint: "",
    WasteGeneration: "",
    Reusability: "",
    DisposalInstructions: "",
    TakeBackProgram: "",
    packagingWeight: "",

    // meltHeatNumber: "",
    // productionCastingBatch: "",
    // materialGrade: "",
    // castingProcess: "",
    // pouringCastingDate: "",




    // rackName: "",
    // bin: "",
  };

  // const validationSchema = Yup.object({
  //   // DPPID: Yup.object()
  //   //   .required("Select DPP Code"),
  //   MaterialSource: Yup.string()
  //     .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
  //     .required(" "),
  //   PlasticContent: Yup.string()
  //     .required(" "),
  //   Biodegradability: Yup.string()
  //     .required(" "),
  //   CarbonFootprint: Yup.string()
  //     .required(" "),
  //   WasteGeneration: Yup.string()
  //     .required(" "),
  //   packagingWeight: Yup.string()
  //     .required(" "),
  //   Reusability: Yup.string()
  //     .required(" "),
  //   DisposalInstructions: Yup.string()
  //     .required(" "),
  //   TakeBackProgram: Yup.string()
  //     .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
  //     .required(" "),

  //   MaterialType: Yup.string()
  //     .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
  //     .required(" "),

  //   Recyclablepercent: Yup.string()
  //     .required(" ")
  //     .matches(/^[0-9]+$/, "Only numbers allowed")
  //     .max(3, "Value cannot exceed 100"),


  //   supplierId: Yup.object()
  //     .nullable()
  //     .required(" "),

  //   Method: Yup.string()
  //     .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
  //     .required(" "),

  //   Collection: Yup.string()
  //     .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
  //     .required(" "),

  //   AuditDate: Yup.date()
  //     .required(" ")
  //     .typeError("Invalid Date"),



  //   // meltHeatNumber: Yup.string().trim().required(" "),
  //   // productionCastingBatch: Yup.string().trim().required(" "),
  //   // materialGrade: Yup.string().trim().required(" "),
  //   // castingProcess: Yup.string().trim().required(" "),
  //   // pouringCastingDate: Yup.date().typeError("Valid date required").required(" "),





  // });


  const getValidationSchema = (industryId) => {
    const id = Number(industryId); // Safe type conversion

    return Yup.object({
      DPPID: Yup.object()
        .nullable()
        .required(" "),
      supplierId: Yup.object()
        .nullable()
        .required(" "),

      AuditDate: Yup.date()
        .required(" ")
        .typeError("Invalid Date"),

      MaterialType: Yup.string()
        .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
        .required(" "),

      Recyclablepercent: Yup.string()
        .required(" ")
        .matches(/^[0-9]+$/, "Only numbers allowed")
        .max(3, "Value cannot exceed 100"),

      Method: Yup.string()
        .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
        .required(" "),

      Collection: Yup.string()
        .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
        .required(" "),

      packagingWeight: Yup.string().required(" "),
      Reusability: Yup.string().required(" "),
      DisposalInstructions: Yup.string().required(" "),
      WasteGeneration: Yup.string().required(" "),
      TakeBackProgram: Yup.string()
        .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
        .required(" "),


      MaterialSource: id === 1
        ? Yup.string()
          .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
          .required(" ")
        : Yup.string()
          .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed"),

      CarbonFootprint: id === 1
        ? Yup.string().required(" ")
        : Yup.string(),

      PlasticContent: (id === 2 || id === 3)
        ? Yup.string().required(" ")
        : Yup.string(),

      Biodegradability: (id === 2 || id === 3)
        ? Yup.string().required(" ")
        : Yup.string(),
    });
  };

  const [errorMsg, setErrorMsg] = useState("");

  const [allocateButtonName, setAllocateButtonName] = useState("Create");

  const onSubmit = async (values, { resetForm }) => {
    setAllocateButtonName("Please wait...");
    const formData = new FormData();

    formData.append("userId", String(userId));
    formData.append("dppId", String(dppIdSelected?.value ?? ""));
    formData.append("packagingMaterialType", String(values.MaterialType ?? ""));
    formData.append("recyclablePercent", String(values.Recyclablepercent ?? ""));
    formData.append("supplierId", String(supplierIdSelected?.value ?? ""));
    formData.append("disposalMethod", String(values.Method ?? ""));
    formData.append("collectionProgram", String(values.Collection ?? ""));
    formData.append("auditDate", String(values.AuditDate ?? ""));
    formData.append("materialSource", String(values.MaterialSource ?? ""));
    formData.append("plasticContent", String(values.PlasticContent ?? ""));
    formData.append("packagingWeight", String(values.packagingWeight ?? ""));
    formData.append("biodegradability", String(values.Biodegradability ?? ""));
    formData.append("carbonFootprint", String(values.CarbonFootprint ?? ""));
    formData.append("wasteGeneration", String(values.WasteGeneration ?? ""));
    formData.append("reusability", String(values.Reusability ?? ""));
    formData.append("disposalInstructions", String(values.DisposalInstructions ?? ""));
    formData.append("takeBackProgram", String(values.TakeBackProgram ?? ""));

    // formData.append("meltHeatNumber", values.meltHeatNumber);
    // formData.append("productionCastingBatch", values.productionCastingBatch);
    // formData.append("materialGrade", values.materialGrade);
    // formData.append("castingProcess", values.castingProcess);
    // formData.append("pouringCastingDate", values.pouringCastingDate);

    // Attach uploaded file if present
    // if (values.file) {
    //   formData.append("attachments", values.file);
    // }

    // console.log("formData", formData);

    let res = await createPackaging(formData, jwtToken);
    if (res.status) {
      setIsSuccessAllocateItem(true);
      // getOpenBinsByWarehouseAndZone(warehouseIdSelected?.value, zoneIdSelected);
      getPackaging(dppIdSelectedForGlobalFilter?.value, jwtToken);
      formik.setErrors({});
      setActivityIdSelected("");
      setWarehouseIdSelected("");
      setZoneIdSelected("");
      setSectionIdSelected("");
      setRackIdSelected("");
      setLocationIdSelected("");
      setTimeout(() => {
        setAllocateButtonName("Create");
        handleCloseAllocateItemModal();
      }, 2250);
    }
    if (!res.status) {
      setErrorMsg(res?.data?.data?.msg);
      setAllocateButtonName("Create");
      setIsErrorAllocateItem(true);
    }
    setSelectedItemCode("");
    setSelectedZoneName("");
    setSelectedBin("");
    // resetForm();
  };

  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleOpenDeleteModal = (data) => {
    setOpenDeleteModal(true);
    setSingleDataForDelete(data);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const [isErrorDeleteAssembly, setIsErrorDeleteAssembly] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState(false);
  const [isSuccessForAssembly, setIsSuccessForAssembly] = useState(false);

  useEffect(() => {
    if (isErrorDeleteAssembly) {
      setTimeout(() => {
        setIsErrorDeleteAssembly(false);
      }, 3000);
    }
  }, [isErrorDeleteAssembly]);
  useEffect(() => {
    if (isSuccessForAssembly) {
      setTimeout(() => {
        setIsSuccessForAssembly(false);
      }, 2000);
    }
  }, [isSuccessForAssembly]);

  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteTripNo = async () => {
    setDeleteButtonName("Please wait...");
    let pkgId = singleDataForDelete.pkgId;
    // let userId = singleDataForDelete.userId;

    let res = await deletePackaging(pkgId, userId);

    if (res.status) {
      getPackaging(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 3000);
      setIsSuccessForAssembly(true);
    }

    if (!res.status) {
      setIsErrorDeleteAssembly(true);
      setErrorMsgForDelete(res?.data?.data?.msg);
      setDeleteButtonName("Delete");
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    // validationSchema,
    validationSchema: () => getValidationSchema(dppIdSelected?.industryId),
  });

  const [isSuccessAddActivityMapping, setIsSuccessAddActivityMapping] =
    useState(false);
  const [isErrorAddActivityMapping, setIsErrorAddActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessAddActivityMapping) {
      setTimeout(() => {
        setIsSuccessAddActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessAddActivityMapping]);

  useEffect(() => {
    if (isErrorAddActivityMapping) {
      setTimeout(() => {
        setIsErrorAddActivityMapping(false);
      }, 3000);
    }
  }, [isErrorAddActivityMapping]);

  const [addActivityMappingModal, setAddActivityMappingModal] = useState(false);
  const handleAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };
  const handleCloseAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };

  const initialValueForAddActivityMapping = {
    bin: "",
  };

  const validationSchemaForAddActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForAddActivityMapping = async (values, { resetForm }) => {
    const payload = {
      warehouseId: warehouseIdSelected?.value,
      itemId: ActivityMappingData.itemId,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedBinForAdd.value,
    };

    setSelectedBinForAdd("");
    resetForm();
  };

  const formikForAdd = useFormik({
    initialValues: initialValueForAddActivityMapping,
    validationSchema: validationSchemaForAddActivityMapping,
    onSubmit: onSubmitForAddActivityMapping,
  });

  const [isSuccessEditActivityMapping, setIsSuccessEditActivityMapping] =
    useState(false);
  const [isErrorEditActivityMapping, setIsErrorEditActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessEditActivityMapping) {
      setTimeout(() => {
        setIsSuccessEditActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessEditActivityMapping]);

  useEffect(() => {
    if (isErrorEditActivityMapping) {
      setTimeout(() => {
        setIsErrorEditActivityMapping(false);
      }, 3000);
    }
  }, [isErrorEditActivityMapping]);

  const [editActivityMappingModal, setEditActivityMappingModal] =
    useState(false);
  const handleEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };

  const handleCloseEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };
  const initialValueForEditActivityMapping = {
    bin: "",
  };

  const validationSchemaForEditActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForEditActivityMapping = async (values, reset) => {
    const payload = {
      itemId: ActivityMappingData.itemId,
      warehouseId: warehouseIdSelected?.value,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedOpenBin?.value,
    };

    // let res = await editBinAllocation(payload, jwtToken);

    // if (res.status) {
    //   setIsSuccessEditActivityMapping(true);
    //   getMappedActivity(warehouseIdSelected?.value, jwtToken);
    // }
    // if (!res.status) {
    //   setIsErrorEditActivityMapping(true);
    // }
    // setSelectedOpenBin("");
  };
  const formikForEdit = useFormik({
    initialValues: initialValueForEditActivityMapping,
    validationSchema: validationSchemaForEditActivityMapping,
    onSubmit: onSubmitForEditActivityMapping,
    enableReinitialize: true,
  });

  const [warehouseTypesSelectedForEdit, setWarehouseTypesSelectedForEdit] =
    useState("");
  const [itemCodeSelectedForEdit, setItemCodeSelectedForEdit] = useState("");
  const [acnTypeSelectedForEdit, setAcnTypeSelectedForEdit] = useState("");
  const [zoneSelectedForEdit, setZoneSelectedForEdit] = useState("");
  const [sectionSelectedForEdit, setSectionSelectedForEdit] = useState("");
  const [rackSelectedForEdit, setRackSelectedForEdit] = useState("");
  const [locationSelectedForEdit, setLocationSelectedForEdit] = useState("");

  const [singleFgDataForUpdate, setSingleFgDataForUpdate] = useState({});
  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const handleOpenUpdateModal = (singleData) => {
    getWarehousesByMovement(singleData.acnId, jwtToken);
    // getZonesByWarehouse(singleData.zoneId, jwtToken);
    getLevel1ByLevel(singleData.warehouseId, 0, jwtToken);
    getLevel2ByLevel(singleData.warehouseId, singleData.zoneId, jwtToken);
    getLevel3ByLevel(singleData.warehouseId, singleData.sectionId, jwtToken);
    getLevel4ByLevel(singleData.warehouseId, singleData.rackId, jwtToken);
    setWarehouseTypesSelectedForEdit({
      label: singleData.warehouseCode,
      value: singleData.warehouseId,
    });
    setdppIdForUpdateSelected({
      label: singleData.dppId,
      value: singleData.dppId,
      industryId: singleData.industryId,

    });
    setSupplierIdSelectedForEdit({
      label: singleData.supplierName,
      value: singleData.supplierId,
    });

    setSingleFgDataForUpdate(singleData);
    setOpenUpdateModal(true);

    // getWarehousesByMovement(
    //   acnTypeSelectedForEdit?.value,

    //   jwtToken
    // );
  };

  const handleChangeWarehouseForEdit = (selectedOption) => {
    setWarehouseTypesSelectedForEdit(selectedOption);
    setZoneSelectedForEdit("");
  };
  const handleChangeAcnForEdit = (selectedOption) => {
    setAcnTypeSelectedForEdit(selectedOption);
  };
  const handleChangeZoneForEdit = (selectedOption) => {
    setZoneSelectedForEdit(selectedOption);
    setSectionSelectedForEdit("");
  };
  const handleChangeSectionForEdit = (selectedOption) => {
    setSectionSelectedForEdit(selectedOption);
    setRackSelectedForEdit("");
  };
  const handleChangeRackForEdit = (selectedOption) => {
    setRackSelectedForEdit(selectedOption);
    setLocationSelectedForEdit("");
  };
  const handleChangeLocationForEdit = (selectedOption) => {
    setLocationSelectedForEdit(selectedOption);
  };

  const [supplierOptions, setSupplierOptions] = useState([]);

  useEffect(() => {
    let tempgetDPPReducer = [];
    let data = getSupplierTypeReducer.dpp.data ? getSupplierTypeReducer.dpp.data : [];
    console.log("datasdsds", data)
    data.map((zone) => {
      tempgetDPPReducer.push({
        label: zone.supplierName,
        value: zone.supplierId,
        industryName: zone.industryName,
        industryId: zone.industryId,

      });
    });
    setSupplierOptions(tempgetDPPReducer);
  }, [getSupplierTypeReducer]);

  const initialValueForUpdate = {
    DPPID: singleFgDataForUpdate.dppCode,
    MaterialType: singleFgDataForUpdate.packagingMaterialType,
    RecyclablePercent: singleFgDataForUpdate.recyclablePercent,
    SupplierID: singleFgDataForUpdate.supplierId,
    DisposalMethod: singleFgDataForUpdate.disposalMethod,
    CollectionProgram: singleFgDataForUpdate.collectionProgram,

    MaterialSource: singleFgDataForUpdate.materialSource,
    packagingWeight: singleFgDataForUpdate.packagingWeight,
    PlasticContent: singleFgDataForUpdate.plasticContent,
    Biodegradability: singleFgDataForUpdate.biodegradability,
    CarbonFootprint: singleFgDataForUpdate.carbonFootprint,
    WasteGeneration: singleFgDataForUpdate.wasteGeneration,
    Reusability: singleFgDataForUpdate.reusability,
    DisposalInstructions: singleFgDataForUpdate.disposalInstructions,
    TakeBackProgram: singleFgDataForUpdate.takeBackProgram,


    // meltHeatNumber: singleFgDataForUpdate.meltHeatNumber,
    // productionCastingBatch: singleFgDataForUpdate.productionCastingBatch,
    // materialGrade: singleFgDataForUpdate.materialGrade,
    // castingProcess: singleFgDataForUpdate.castingProcess,
    // pouringCastingDate: singleFgDataForUpdate.pouringCastingDate,

    // AuditDate: singleFgDataForUpdate.cd
    // AuditDate: singleFgDataForUpdate.cd
    AuditDate: singleFgDataForUpdate.auditDate
      ? (() => {
        const [month, day, year] =
          singleFgDataForUpdate.auditDate.split("/");
        return `${year}-${month}-${day}`; // yyyy-MM-dd
      })()
      : "",

  };

  const handleCloseModal = (event, reason) => {
    if (reason === "backdropClick")
      return;
    setOpenUpdateModal(false);
    formikForUpdate.setErrors({});
    formikForUpdate.setValues(initialValueForUpdate);
  };
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const [editButtonName, setEditButtonName] = useState("Update");

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    const formData = new FormData();

    formData.append("udBy", String(userId));
    formData.append("pkgId", String(singleFgDataForUpdate?.pkgId ?? ""));
    formData.append(
      "packagingMaterialType",
      String(values.MaterialType ?? "")
    );
    formData.append(
      "recyclablePercent",
      String(values.RecyclablePercent ?? "")
    );
    formData.append(
      "supplierId",
      String(values.SupplierID ?? "")
    );
    formData.append(
      "disposalMethod",
      String(values.DisposalMethod ?? "")
    );
    formData.append(
      "collectionProgram",
      String(values.CollectionProgram ?? "")
    );
    formData.append(
      "packagingWeight",
      String(values.packagingWeight ?? "")
    );
    formData.append(
      "auditDate",
      String(values.AuditDate ?? "")
    );
    formData.append(
      "materialSource",
      String(values.MaterialSource ?? "")
    );
    formData.append(
      "plasticContent",
      String(values.PlasticContent ?? "")
    );
    formData.append(
      "biodegradability",
      String(values.Biodegradability ?? "")
    );
    formData.append(
      "carbonFootprint",
      String(values.CarbonFootprint ?? "")
    );
    formData.append(
      "wasteGeneration",
      String(values.WasteGeneration ?? "")
    );
    formData.append(
      "reusability",
      String(values.Reusability ?? "")
    );
    formData.append(
      "disposalInstructions",
      String(values.DisposalInstructions ?? "")
    );
    formData.append(
      "takeBackProgram",
      String(values.TakeBackProgram ?? "")
    );

    // Attach uploaded file if present
    // if (values.file) {
    //   formData.append("attachments", values.file);
    // }

    console.log("formData", formData);

    let res = await editPackaging(formData, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getPackaging(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseModal();
        setEditButtonName("Update");
      }, 3000);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setEditButtonName("Update");
    }
  };


  const validationSchemaForAssembly = Yup.object({

    MaterialSource: Yup.string()
      .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
      .required(" "),
    PlasticContent: Yup.string()
      .required(" "),
    Biodegradability: Yup.string()
      .required(" "),
    CarbonFootprint: Yup.string()
      .required(" "),
    WasteGeneration: Yup.string()
      .required(" "),
    packagingWeight: Yup.string()
      .required(" "),
    Reusability: Yup.string()
      .required(" "),
    DisposalInstructions: Yup.string()
      .required(" "),
    TakeBackProgram: Yup.string()
      .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
      .required(" "),

    MaterialType: Yup.string()
      .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
      .required(" "),

    RecyclablePercent: Yup.string()
      .required(" ")
      .matches(/^[0-9]+$/, "Only numbers allowed")
      .max(3, "Value cannot exceed 100"),

    supplierId: Yup.object()
      .nullable()
      .required(" "),

    DisposalMethod: Yup.string()
      .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
      .required(" "),

    CollectionProgram: Yup.string()
      .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
      .required(" "),

    AuditDate: Yup.date()
      .required(" ")
      .typeError("Invalid Date"),

  });


  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForAssembly,
    validationSchema: () => getValidationSchema(dppIdForUpdateSelected?.industryId),
    enableReinitialize: true,
  });
  const [isErrorDeleteActivityMapping, setIsErrorDeleteActivityMapping] =
    useState(false);
  useEffect(() => {
    if (isErrorDeleteActivityMapping) {
      setTimeout(() => {
        setIsErrorDeleteActivityMapping(false);
      }, 3000);
    }
  }, [isErrorDeleteActivityMapping]);

  const [openDeleteActivityMappingModal, setOpenDeleteActivityMappingModal] =
    useState(false);

  const handleOpenDeleteActivityMappingModal = (data = {}) => {
    setActivityMappingData(data);
    setOpenDeleteActivityMappingModal(true);
  };

  const handleCloseDeleteActivityMappingModal = () => {
    setOpenDeleteActivityMappingModal(false);
  };

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");
  // const [editButtonName, setEditButtonName] = useState("Submit");

  const onClickDeleteActivityMapping = async () => {
    // let res = await removeBinAllocation(
    //   warehouseIdSelected?.value,
    //   ActivityMappingData.itemId,
    //   ActivityMappingData.zoneId,
    //   ActivityMappingData.locationId,
    //   jwtToken
    // );
    // if (res.status) {
    //   getMappedActivity(warehouseIdSelected?.value, jwtToken);
    //   setOpenDeleteActivityMappingModal(false);
    // }
    // if (!res.status) {
    //   setDeleteErrorMsg(res.data.response.data.msg);
    //   setIsErrorDeleteActivityMapping(true);
    // }
  };

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);
  const data = getRelationLocationReducer.locations?.data || [];
  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };
  const [uploadCsvData, setUploadCsvData] = useState({});

  // const uploadCsvHandler = async () => {
  //   let data = new FormData();

  //   data.append("file", uploadCsvData);

  //   let res = await uploadForPackaging(data , jwtToken);

  //   if (res.status) {
  //     getPackaging(dppIdSelectedForGlobalFilter?.value, jwtToken);
  //     setUploadCsvFilter(false);
  //     DataUploadSuccessNotification();
  //   }

  //   if (!res.status) {
  //     DataUploadFailureNotification(res?.data?.data?.msg);
  //   }
  // };

  const uploadCsvHandler = async () => {
    if (!uploadCsvData) {
      toast.error("Please select a CSV file first!");
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadCsvData);

    try {
      let res = await uploadForPackaging(formData, jwtToken);

      if (res?.status === true || res?.data?.status === true) {
        getPackaging(dppIdSelectedForGlobalFilter?.value, jwtToken);
        setUploadCsvFilter(false);
      }

      showUploadNotification(res);

    } catch (error) {
      showUploadNotification(error);
    }
  };



  const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  const subModuleId = "7e02c688-4e21-4805-9f51-2320dda92382";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);
  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getPackaging(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    // <DashboardLayout>
    //   <DashboardNavbar />
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox color="text" px={2} ml={-2} mb={4}>
                {allocateAccess && (
                  <Tooltip>
                    <CreateButton
                      tooltip="Add Packaging"
                      color="info"
                      variant="contained"
                      type="button"
                      iconOnly
                      onClick={(event) => {
                        handleAllocateItemModal();
                        getWarehouses(jwtToken);
                        getItemMaster(jwtToken);
                        getAcn(jwtToken);
                        getRelationLocation(jwtToken);
                      }}
                      style={{ borderRadius: "5px" }}
                      size="small"
                    >
                      <Icon>add</Icon>
                    </CreateButton>
                  </Tooltip>
                )}
                <CSVLink {...csvLink}  >
                  <DownloadDataButton
                    tooltip="Download Packaging List"
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadDataButton>
                </CSVLink>

                {
                  //  uploadFG && 
                  (
                    <UploadButton
                      tooltip="Upload CSV"
                      //   disabled={!uploadItem}
                      style={{ marginLeft: "1rem" }}
                      type="button"
                      variant="outlined"
                      color="info"
                      iconOnly
                      onClick={uploadCsvFilterHandler}
                    >
                      <Icon>upload</Icon>
                    </UploadButton>
                  )}

                <CSVLink {...csvLink2}>
                  <DownloadButton
                    tooltip="Download Template"
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadButton>
                </CSVLink>
                {/* <Tooltip title="Upload CSV">
                    <MDButton
                      style={{ marginLeft: "1rem" }}
                      // disabled={!uploadItem}
                      type="button"
                      variant="outlined"
                      color="info"
                      iconOnly
                      onClick={uploadCsvFilterHandler}
                    >
                      <Icon>upload</Icon>
                    </MDButton>
                  </Tooltip> */}

              </MDBox>
            </MDBox>

            {uploadCsvFilter && (
              <div style={{ marginLeft: "1", marginTop: "0.5rem" }}>
                <div>
                  <input
                    className="choose_file"
                    style={{
                      marginTop: "1.5rem",
                      marginLeft: "1.5rem",
                      // marginBottom: "-9rem",
                    }}
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      setUploadCsvData(e.target.files[0]);
                    }}
                  />
                  <MDButton
                    disabled={
                      !uploadCsvData?.name || uploadCsvData?.type !== "text/csv"
                    }
                    variant="contained"
                    color="info"
                    style={{
                      marginLeft: { xs: "1.5rem", lg: "1" },
                      marginTop: "0rem",
                    }}
                    type="button"
                    onClick={uploadCsvHandler}
                  >
                    UPLOAD
                  </MDButton>
                </div>
                <div style={{ marginBottom: "-20px" }}>
                  <span
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginLeft: "30px",
                      fontStyle: "italic",
                    }}
                  >
                    <strong>*</strong> Please upload
                    <strong>".csv"</strong> file only
                  </span>
                </div>
              </div>
            )}
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                  // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            <MDBox pt={0}>
              {loadingForDynamicColumn && (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  options={{ draggable: false }}
                  // serverSidePagination={true}
                  // paginationObj={paginationObj}
                  // pageNoValue={pageNo}
                  // rowsPerPageValue={rowsPerPage}
                  // pageNoProp={importPageNo}
                  // rowsPerPageProp={importRowsPerPage}
                  // searchProp={importSearch}
                  loading={loading}
                  hideColumns={hiddenColumsDetails}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                />
              )}
            </MDBox>
            <Modal
              open={openDeleteModal}
              onClose={handleCloseDeleteModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ marginLeft: "0.5rem" }}
                    color="error"
                    onClick={deleteTripNo}
                    disabled={deleteButtonName === "Please wait..."}
                  >
                    {deleteButtonName}
                  </MDButton>
                  <MDBox mt={2}>
                    <Collapse in={isErrorDeleteAssembly}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorDeleteAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForDelete}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessForAssembly}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessForAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Deleted Successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openUpdateModal}
              onClose={handleCloseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginRight: "10px",
                          marginTop: "4px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox>
                      {/* pkgId:singleFgDataForUpdate.pkgId,
     packagingMaterialType :values.MaterialType,
     recyclablePercent :values.RecyclablePercent,
     supplierId :values.SupplierID,
     disposalMethod :values.DisposalMethod,
     collectionProgram :values.CollectionProgram,
     auditDate :values.AuditDate, */}
                      <Grid container spacing={1}>
                        {/* <Grid item xs={12} lg={6}>
                              <MDBox ml={1}>
                                            <MDTypography variant="h6">DPP ID</MDTypography>
                                            <MDInput
                                              type="number"
                                              name="DPPID"
                                              fullWidth
                                              autoComplete="off"
                                              onBlur={formikForUpdate.handleBlur}
                                              onChange={formikForUpdate.handleChange}
                                              value={formikForUpdate.values.DPPID}
                                              error={
                                                formikForUpdate.touched.DPPID &&
                                                formikForUpdate.errors.DPPID &&
                                                true
                                              }
                                              inputProps={{
                                                style: {
                                                  height: "10px",
                                                },
                                                maxLength: 45,
                                              }}
                                            />
                                            {formikForUpdate.touched.DPPID &&
                                              formikForUpdate.errors.DPPID && (
                                                <TextError msg={formikForUpdate.errors.DPPID} />
                                              )}
                                          </MDBox>
                      </Grid> */}
                        {/* <Grid item xs={12} lg={6}>
                                                                    <MDBox  mb={1} >
                                                                      <MDTypography
                                                                        variant="h6"
                                                                        style={{ fontWeight: "500" }}
                                                                      >
                                                                        {" "}
                                                                        DPP ID{" "}
                                                                      </MDTypography>
                                            
                                                                      <Select
                                                                        // isDisabled={activityIdSelected ? false : true}
                                                                        isClearable
                                                                        className="select-css"
                                                                        maxMenuHeight={130}
                                                                        placeholder="Choose one..."
                                                                        name="DPPID"
                                                                        onBlur={() => {
                                                                          formikForUpdate.handleBlur({
                                                                            target: { name: "DPPID" },
                                                                          });
                                                                        }}
                                                                        value={dppIdForUpdateSelected}
                                                                        options={dppOptions}
                                                                        onChange={(selectedOption) => {
                                                                          handleChangeDppForUpdate(selectedOption);
                                                                          // getZonesByWarehouse(selectedOption?.value);
                                                                          formikForUpdate.setFieldValue(
                                                                            "DPPID",
                                                                            selectedOption
                                                                          );
                                                                      
                                                                        }}
                                                                      />
                                                                      {formikForUpdate.touched.DPPID &&
                                                                        formikForUpdate.errors.DPPID && (
                                                                          <TextError msg={formikForUpdate.errors.DPPID} />
                                                                        )}
                                                                    </MDBox>
                                                                  </Grid> */}
                        <Grid item xs={12} lg={6}>
                          <MDBox >
                            <MDTypography variant="h6">DPP Code</MDTypography>
                            <MDInput
                              type="text"
                              name="DPPID"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.DPPID}
                              error={
                                formikForUpdate.touched.DPPID &&
                                formikForUpdate.errors.DPPID &&
                                true
                              }
                              disabled={true}
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.DPPID &&
                              formikForUpdate.errors.DPPID && (
                                <TextError msg={formikForUpdate.errors.DPPID} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Material Type
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="MaterialType"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.MaterialType}
                              error={
                                formikForUpdate.touched.MaterialType &&
                                formikForUpdate.errors.MaterialType &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.MaterialType &&
                              formikForUpdate.errors.MaterialType && (
                                <TextError
                                  msg={formikForUpdate.errors.MaterialType}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6} mt={2}>
                          <MDBox>
                            <MDTypography variant="h6">
                              Recyclable Percent
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="RecyclablePercent"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.RecyclablePercent}
                              error={
                                formikForUpdate.touched.RecyclablePercent &&
                                formikForUpdate.errors.RecyclablePercent &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.RecyclablePercent &&
                              formikForUpdate.errors.RecyclablePercent && (
                                <TextError
                                  msg={formikForUpdate.errors.RecyclablePercent}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6} mt={2}>
                          <MDBox ml={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              {" "}
                              Supplier Name{" "}
                            </MDTypography>

                            <Select
                              // isDisabled={activityIdSelected ? false : true}
                              isClearable
                              className="select-css"
                              maxMenuHeight={200}
                              placeholder="Choose one..."
                              name="supplierId"
                              onBlur={() => {
                                formikForUpdate.handleBlur({
                                  target: { name: "supplierId" },
                                });
                              }}
                              value={supplierIdSelectedForEdit}
                              options={supplierOptions}
                              onChange={(selectedOption) => {
                                handleChangeSupplierForEdit(selectedOption);
                                // getZonesByWarehouse(selectedOption?.value);
                                formikForUpdate.setFieldValue("supplierId", selectedOption);
                              }}
                            />
                            {formikForUpdate.touched.supplierId && formikForUpdate.errors.supplierId && (
                              <TextError msg={formikForUpdate.errors.supplierId} />
                            )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6} mt={2}>
                          <MDBox>
                            <MDTypography variant="h6">
                              Disposal Method
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="DisposalMethod"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.DisposalMethod}
                              error={
                                formikForUpdate.touched.DisposalMethod &&
                                formikForUpdate.errors.DisposalMethod &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.DisposalMethod &&
                              formikForUpdate.errors.DisposalMethod && (
                                <TextError
                                  msg={formikForUpdate.errors.DisposalMethod}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6} mt={2}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Collection Program
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="CollectionProgram"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.CollectionProgram}
                              error={
                                formikForUpdate.touched.CollectionProgram &&
                                formikForUpdate.errors.CollectionProgram &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.CollectionProgram &&
                              formikForUpdate.errors.CollectionProgram && (
                                <TextError
                                  msg={formikForUpdate.errors.CollectionProgram}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6} mt={2}>
                          <MDBox>
                            <MDTypography variant="h6">Audit Date</MDTypography>
                            <MDInput
                              type="date"
                              name="AuditDate"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.AuditDate}
                              error={
                                formikForUpdate.touched.AuditDate &&
                                formikForUpdate.errors.AuditDate &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.AuditDate &&
                              formikForUpdate.errors.AuditDate && (
                                <TextError
                                  msg={formikForUpdate.errors.AuditDate}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6} mt={2}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Material Source</MDTypography>
                            <MDInput
                              type="text"
                              name="MaterialSource"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.MaterialSource}
                              error={
                                formikForUpdate.touched.MaterialSource &&
                                formikForUpdate.errors.MaterialSource &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.MaterialSource &&
                              formikForUpdate.errors.MaterialSource && (
                                <TextError msg={formikForUpdate.errors.MaterialSource} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6} mt={2}>
                          <MDBox mb={2}>
                            <MDTypography variant="h6">Packaging Weight(kg)</MDTypography>
                            <MDInput
                              type="number"
                              name="packagingWeight"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.packagingWeight}
                              error={
                                formikForUpdate.touched.packagingWeight &&
                                formikForUpdate.errors.packagingWeight &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.packagingWeight &&
                              formikForUpdate.errors.packagingWeight && (
                                <TextError msg={formikForUpdate.errors.packagingWeight} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6} mt={2}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Plastic Content(%)</MDTypography>
                            <MDInput
                              type="number"
                              name="PlasticContent"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.PlasticContent}
                              error={
                                formikForUpdate.touched.PlasticContent &&
                                formikForUpdate.errors.PlasticContent &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.PlasticContent &&
                              formikForUpdate.errors.PlasticContent && (
                                <TextError msg={formikForUpdate.errors.PlasticContent} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox mb={2}>
                            <MDTypography variant="h6">Biodegradability</MDTypography>
                            <MDInput
                              type="number"
                              name="Biodegradability"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.Biodegradability}
                              error={
                                formikForUpdate.touched.Biodegradability &&
                                formikForUpdate.errors.Biodegradability &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.Biodegradability &&
                              formikForUpdate.errors.Biodegradability && (
                                <TextError msg={formikForUpdate.errors.Biodegradability} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox mb={2} ml={1}>
                            <MDTypography variant="h6">Carbon Footprint(kg CO₂)</MDTypography>
                            <MDInput
                              type="number"
                              name="CarbonFootprint"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.CarbonFootprint}
                              error={
                                formikForUpdate.touched.CarbonFootprint &&
                                formikForUpdate.errors.CarbonFootprint &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.CarbonFootprint &&
                              formikForUpdate.errors.CarbonFootprint && (
                                <TextError msg={formikForUpdate.errors.CarbonFootprint} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox mb={2}>
                            <MDTypography variant="h6">Waste Generation(kg/capita)</MDTypography>
                            <MDInput
                              type="number"
                              name="WasteGeneration"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.WasteGeneration}
                              error={
                                formikForUpdate.touched.WasteGeneration &&
                                formikForUpdate.errors.WasteGeneration &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.WasteGeneration &&
                              formikForUpdate.errors.WasteGeneration && (
                                <TextError msg={formikForUpdate.errors.WasteGeneration} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox mb={2} ml={1}>
                            <MDTypography variant="h6">Reusability</MDTypography>
                            <MDInput
                              type="text"
                              name="Reusability"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.Reusability}
                              error={
                                formikForUpdate.touched.Reusability &&
                                formikForUpdate.errors.Reusability &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.Reusability &&
                              formikForUpdate.errors.Reusability && (
                                <TextError msg={formikForUpdate.errors.Reusability} />
                              )}
                          </MDBox>
                        </Grid>


                        <Grid item xs={12} lg={6}>
                          <MDBox mb={2}>
                            <MDTypography variant="h6">Disposal Instructions</MDTypography>
                            <MDInput
                              type="text"
                              name="DisposalInstructions"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.DisposalInstructions}
                              error={
                                formikForUpdate.touched.DisposalInstructions &&
                                formikForUpdate.errors.DisposalInstructions &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.DisposalInstructions &&
                              formikForUpdate.errors.DisposalInstructions && (
                                <TextError msg={formikForUpdate.errors.DisposalInstructions} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox mb={2} ml={1}>
                            <MDTypography variant="h6">Take BackProgram</MDTypography>
                            <MDInput
                              type="text"
                              name="TakeBackProgram"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.TakeBackProgram}
                              error={
                                formikForUpdate.touched.TakeBackProgram &&
                                formikForUpdate.errors.TakeBackProgram &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.TakeBackProgram &&
                              formikForUpdate.errors.TakeBackProgram && (
                                <TextError msg={formikForUpdate.errors.TakeBackProgram} />
                              )}
                          </MDBox>
                        </Grid>

                        {/* <Grid item xs={12} lg={6}>
                          <MDBox mb={2} ml={1} >
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Status
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={70}
                              placeholder="Select..."
                              name="location"
                              options={level4Options}
                              value={locationSelectedForEdit} // Ensure this matches the shape of options
                              onChange={(selectedOption) => {
                                handleChangeLocationForEdit(selectedOption);
                                formikForUpdateForUpdate.setFieldValue(
                                  "location",
                                  selectedOption
                                );
                              }}
                            />
                            {formikForUpdateForUpdate.touched.location &&
                              formikForUpdate.errors.location && (
                                <TextError
                                  msg={formikForUpdate.errors.location}
                                />
                              )}
                          </MDBox>
                        </Grid> */}

                        <Grid item xs={12} >
                          <MDBox>
                            <Collapse in={isErrorForUpdate}>
                              <Alert
                                severity="error"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsErrorForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                {errorMsgForUpdate}
                              </Alert>
                            </Collapse>
                            <Collapse in={isSuccessForUpdate}>
                              <Alert
                                severity="success"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsSuccessForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                Updated successfully
                              </Alert>
                            </Collapse>
                          </MDBox>
                        </Grid>
                        {/* <MDBox mt={3} ml={10}> */}

                        {/* <MDButton
                          // variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton> */}

                        {/* Cancel Button */}

                        {/* Submit Button */}
                        <MDButton
                          color="info"
                          type="submit"
                          fullWidth
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={allocateItemModal}
              onClose={handleCloseAllocateItemModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Packaging Waste Record
                  </MDTypography>
                  <MDBox>
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginRight: "10px",
                            marginTop: "4px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseAllocateItemModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <Grid container>
                      {/* <Grid item xs={12} lg={6}>
                              <MDBox mb={2}>
                                            <MDTypography variant="h6">DPP ID</MDTypography>
                                            <MDInput
                                              type="number"
                                              name="DPPID"
                                              fullWidth
                                              autoComplete="off"
                                              onBlur={formik.handleBlur}
                                              onChange={formik.handleChange}
                                              value={formik.values.DPPID}
                                              error={
                                                formik.touched.DPPID &&
                                                formik.errors.DPPID &&
                                                true
                                              }
                                              inputProps={{
                                                style: {
                                                  height: "10px",
                                                },
                                                maxLength: 45,
                                              }}
                                            />
                                            {formik.touched.DPPID &&
                                              formik.errors.DPPID && (
                                                <TextError msg={formik.errors.DPPID} />
                                              )}
                                          </MDBox>
                      </Grid> */}
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} position="relative">
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            DPP Code
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={200}
                            placeholder="Choose one..."
                            name="DPPID"
                            onBlur={() => {
                              formik.handleBlur({ target: { name: "DPPID" } });
                            }}
                            value={dppIdSelected}
                            options={dppOptions}
                            onChange={(selectedOption) => {
                              handleChangeDpp(selectedOption);
                              formik.setFieldValue("DPPID", selectedOption);
                            }}
                          />

                          {formik.touched.DPPID && formik.errors.DPPID && (
                            <div
                              style={{
                                position: "absolute",
                                right: "38px",
                                top: "33px",
                                color: "#f7554a",
                                pointerEvents: "none",
                              }}
                            >
                              <span
                                className="material-icons"
                                style={{ fontSize: "18px", color: "#f7554a" }}
                              >
                                error_outline
                              </span>
                            </div>
                          )}

                          {formik.touched.DPPID && formik.errors.DPPID && (
                            <TextError msg={formik.errors.DPPID} />
                          )}
                        </MDBox>
                      </Grid>


                      <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Material Type
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="MaterialType"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.MaterialType}
                            error={
                              formik.touched.MaterialType &&
                              formik.errors.MaterialType &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.MaterialType &&
                            formik.errors.MaterialType && (
                              <TextError msg={formik.errors.MaterialType} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox >
                          <MDTypography variant="h6">
                            Recyclable percent
                          </MDTypography>
                          <MDInput
                            type="text"

                            placeholder="Enter number"
                            name="Recyclablepercent"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Recyclablepercent}
                            error={
                              formik.touched.Recyclablepercent &&
                              formik.errors.Recyclablepercent &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.Recyclablepercent &&
                            formik.errors.Recyclablepercent && (
                              <TextError
                                msg={formik.errors.Recyclablepercent}
                              />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Supplier Name{" "}
                          </MDTypography>

                          <Select
                            // isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={200}
                            placeholder="Choose one..."
                            name="supplierId"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "supplierId" },
                              });
                            }}
                            value={supplierIdSelected}
                            options={supplierOptions}
                            onChange={(selectedOption) => {
                              handleChangeSupplier(selectedOption);
                              // getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue("supplierId", selectedOption);
                            }}
                          />
                          {formik.touched.supplierId && formik.errors.supplierId && (
                            <TextError msg={formik.errors.supplierId} />
                          )}
                        </MDBox>
                      </Grid>
                      {/* <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Supplier ID</MDTypography>
                          <MDInput
                            type="text"
                            name="SupplierId"
                            
                             placeholder="Enter number"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.SupplierId}
                            error={
                              formik.touched.SupplierId &&
                              formik.errors.SupplierId &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.SupplierId &&
                            formik.errors.SupplierId && (
                              <TextError msg={formik.errors.SupplierId} />
                            )}
                        </MDBox>
                      </Grid> */}
                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox >
                          <MDTypography variant="h6">
                            Disposal Method
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="Method"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Method}
                            error={
                              formik.touched.Method &&
                              formik.errors.Method &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.Method && formik.errors.Method && (
                            <TextError msg={formik.errors.Method} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Collection</MDTypography>
                          <MDInput
                            type="text"
                            name="Collection"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Collection}
                            error={
                              formik.touched.Collection &&
                              formik.errors.Collection &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.Collection &&
                            formik.errors.Collection && (
                              <TextError msg={formik.errors.Collection} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox>
                          <MDTypography variant="h6">Audit Date</MDTypography>
                          <MDInput
                            type="date" // Change this from "text" to "date"
                            name="AuditDate"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.AuditDate}
                            error={
                              formik.touched.AuditDate &&
                              formik.errors.AuditDate &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                            }}
                          />
                          {formik.touched.AuditDate &&
                            formik.errors.AuditDate && (
                              <TextError msg={formik.errors.AuditDate} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Material Source</MDTypography>
                          <MDInput
                            type="text"
                            name="MaterialSource"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.MaterialSource}
                            error={
                              formik.touched.MaterialSource &&
                              formik.errors.MaterialSource &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.MaterialSource &&
                            formik.errors.MaterialSource && (
                              <TextError msg={formik.errors.MaterialSource} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox>
                          <MDTypography variant="h6">Packaging Weight(kg)</MDTypography>
                          <MDInput
                            type="number"
                            name="packagingWeight"
                            fullWidth
                            autoComplete="off"

                            placeholder="Enter number"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.packagingWeight}
                            error={
                              formik.touched.packagingWeight &&
                              formik.errors.packagingWeight &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.packagingWeight &&
                            formik.errors.packagingWeight && (
                              <TextError msg={formik.errors.packagingWeight} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Plastic Content(%)</MDTypography>
                          <MDInput
                            type="number"
                            name="PlasticContent"

                            placeholder="Enter number"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.PlasticContent}
                            error={
                              formik.touched.PlasticContent &&
                              formik.errors.PlasticContent &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.PlasticContent &&
                            formik.errors.PlasticContent && (
                              <TextError msg={formik.errors.PlasticContent} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox>
                          <MDTypography variant="h6">Biodegradability(%)</MDTypography>
                          <MDInput
                            type="number"
                            name="Biodegradability"

                            placeholder="Enter number"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Biodegradability}
                            error={
                              formik.touched.Biodegradability &&
                              formik.errors.Biodegradability &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.Biodegradability &&
                            formik.errors.Biodegradability && (
                              <TextError msg={formik.errors.Biodegradability} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">CarbonFootprint(kg CO₂)</MDTypography>
                          <MDInput
                            type="number"
                            name="CarbonFootprint"
                            placeholder="Enter number"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.CarbonFootprint}
                            error={
                              formik.touched.CarbonFootprint &&
                              formik.errors.CarbonFootprint &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.CarbonFootprint &&
                            formik.errors.CarbonFootprint && (
                              <TextError msg={formik.errors.CarbonFootprint} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox >
                          <MDTypography variant="h6">Waste Generation(kg/capita)</MDTypography>
                          <MDInput
                            type="number"
                            name="WasteGeneration"
                            fullWidth
                            autoComplete="off"

                            placeholder="Enter number"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.WasteGeneration}
                            error={
                              formik.touched.WasteGeneration &&
                              formik.errors.WasteGeneration &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.WasteGeneration &&
                            formik.errors.WasteGeneration && (
                              <TextError msg={formik.errors.WasteGeneration} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Reusability(cycles)</MDTypography>
                          <MDInput
                            type="text"
                            name="Reusability"
                            fullWidth

                            placeholder="Enter number"
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Reusability}
                            error={
                              formik.touched.Reusability &&
                              formik.errors.Reusability &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.Reusability &&
                            formik.errors.Reusability && (
                              <TextError msg={formik.errors.Reusability} />
                            )}
                        </MDBox>
                      </Grid>


                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox >
                          <MDTypography variant="h6">Disposal Instructions</MDTypography>
                          <MDInput
                            type="text"
                            name="DisposalInstructions"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.DisposalInstructions}
                            error={
                              formik.touched.DisposalInstructions &&
                              formik.errors.DisposalInstructions &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.DisposalInstructions &&
                            formik.errors.DisposalInstructions && (
                              <TextError msg={formik.errors.DisposalInstructions} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Take BackProgram</MDTypography>
                          <MDInput
                            type="text"
                            name="TakeBackProgram"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.TakeBackProgram}
                            error={
                              formik.touched.TakeBackProgram &&
                              formik.errors.TakeBackProgram &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.TakeBackProgram &&
                            formik.errors.TakeBackProgram && (
                              <TextError msg={formik.errors.TakeBackProgram} />
                            )}
                        </MDBox>
                      </Grid>


                      {/* <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Warehouse Code{" "}
                          </MDTypography>

                          <Select
                            isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="warehouseCode"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "warehouseCode" },
                              });
                            }}
                            value={warehouseIdSelected}
                            options={warehouseOptionsByMovement}
                            onChange={(selectedOption) => {
                              handleChangeWarehouse(selectedOption);
                              getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue(
                                "warehouseCode",
                                selectedOption
                              );
                              getLevel1ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel2ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel3ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel4ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                            }}
                          />
                          {formik.touched.warehouseCode &&
                            formik.errors.warehouseCode && (
                              <TextError msg={formik.errors.warehouseCode} />
                            )}
                        </MDBox>
                      </Grid> */}

                      <Grid item xs={12} mt={2}>
                        <Collapse in={isErrorAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Created Successfully
                          </Alert>
                        </Collapse>
                      </Grid>

                      {/* Cancel Button */}
                      {/* <MDButton
      color="error"
      onClick={handleCloseAllocateItemModal}   // put your cancel logic
    >
      Cancel
    </MDButton> */}

                      {/* Submit Button */}
                      <MDButton
                        color="info"
                        type="submit"
                        fullWidth
                        disabled={allocateButtonName === "Please wait..."}
                      >
                        {allocateButtonName}
                      </MDButton>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {/* <Footer /> */}
    </div>
    // </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    warehouses: state.warehouses,
    getPackagingReducer: state.getPackagingReducer,
    itemMaster: state.itemMaster,
    zonesByWarehouse: state.zonesByWarehouse,
    getLevel1ByLevelReducer: state.getLevel1ByLevelReducer,
    getLevel2ByLevelReducer: state.getLevel2ByLevelReducer,
    getLevel3ByLevelReducer: state.getLevel3ByLevelReducer,
    getLevel4ByLevelReducer: state.getLevel4ByLevelReducer,
    getAcnReducer: state.getAcnReducer,
    openBinsByWarehouse: state.openBinsByWarehouse,
    getRelationLocationReducer: state.getRelationLocationReducer,
    getWarehouseByMovementReducer: state.getWarehouseByMovementReducer,
    levelsByWarehouseReducer: state.levelsByWarehouseReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
    getSupplierTypeReducer: state.getSupplierTypeReducer,
    getDPPReducer: state.getDPPReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),
    getPackaging: (dppId, jwtToken) => dispatch(getPackaging(dppId, jwtToken)),
    getDppIds: (jwtToken) => dispatch(getDppIds(jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getZonesByWarehouse: (id, jwtToken) =>
      dispatch(getZonesByWarehouse(id, jwtToken)),
    getLevel1ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel1ByLevel(warehouseId, parentId, jwtToken)),
    getLevel2ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevel(warehouseId, parentId, jwtToken)),
    getLevel3ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevel(warehouseId, parentId, jwtToken)),
    getLevel4ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevel(warehouseId, parentId, jwtToken)),

    getSupplierType: (jwtToken) => dispatch(getSupplierType(jwtToken)),
    getAcn: (jwtToken) => dispatch(getAcn(jwtToken)),
    getOpenBinsByWarehouseAndZone: (id, zoneId, jwtToken) =>
      dispatch(getOpenBinsByWarehouseAndZone(id, zoneId, jwtToken)),
    createPackaging: (payload, jwtToken) =>
      dispatch(createPackaging(payload, jwtToken)),
    deletePackaging: (pkgId, userId, jwtToken) =>
      dispatch(deletePackaging(pkgId, userId, jwtToken)),
    uploadForPackaging: (payload, jwtToken) =>
      dispatch(uploadForPackaging(payload, jwtToken)),
    getRelationLocation: (jwtToken) => dispatch(getRelationLocation(jwtToken)),
    getWarehousesByMovement: (activityIdSelected, jwtToken) =>
      dispatch(getWarehousesByMovement(activityIdSelected, jwtToken)),
    editPackaging: (payload, jwtToken) =>
      dispatch(editPackaging(payload, jwtToken)),
    getLevelsByWarehouse: (warehouseId, jwtToken) =>
      dispatch(getLevelsByWarehouse(warehouseId, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Packaging);
